import type { AgencySubscriptionUsageFieldsFragment } from '~/api/graphql';
import { formatUsd } from './usage-limits-utils';
import { overageDeliveryCopy, overageMeterLabel } from './usage-overage-utils';

type Estimate = NonNullable<AgencySubscriptionUsageFieldsFragment['currentOverageBillEstimate']>;

type UsageOverageEstimateProps = {
  estimate: Estimate;
};

export const UsageOverageEstimate = ({ estimate }: UsageOverageEstimateProps) => {
  const hasOverage = estimate.lineItems.length > 0 && estimate.totalDollars > 0;

  return (
    <div className="divide-y divide-neutral-200 dark:divide-neutral-700 overflow-hidden rounded-lg bg-white dark:bg-neutral-800 shadow">
      <div className="flex items-start justify-between gap-4 px-4 py-5 sm:px-6">
        <div className="min-w-0">
          <h3 className="m-0 p-0 text-lg font-medium text-neutral-900 dark:text-white">
            Upcoming overage
          </h3>
          <p className="mt-1 text-sm text-neutral-500 dark:text-neutral-400">
            {hasOverage ? overageDeliveryCopy(estimate.deliveryMethod) : 'No overage this period'}
          </p>
        </div>
        <p className="m-0 shrink-0 text-lg font-medium text-neutral-900 dark:text-white">
          {formatUsd(estimate.totalDollars)}
        </p>
      </div>
      {hasOverage && (
        <div className="space-y-2 px-4 py-5 sm:px-6">
          {estimate.lineItems.map((item) => (
            <div key={item.meterCode} className="flex items-center justify-between gap-4">
              <p className="m-0 text-sm text-neutral-700 dark:text-neutral-300">
                {overageMeterLabel(item.meterCode)}
              </p>
              <p className="m-0 text-sm text-neutral-900 dark:text-white">
                {formatUsd(item.amountDollars)}
              </p>
            </div>
          ))}
        </div>
      )}
      <div className="px-4 py-3 sm:px-6">
        <p className="m-0 text-xs text-neutral-500 dark:text-neutral-400">Estimate. Before tax.</p>
      </div>
    </div>
  );
};
